import { /* baseClient, */ authClient, API } from "../../utils/index";

// Get all boatTypes
export const getBoatTypes = () => {
	return authClient().get(`${API}/boatType`);
};

// Get boatType by id
export const getBoatTypeById = (id) => {
	return authClient().get(`${API}/boatType/${id}`);
};

// Delete boatType
export const deleteBoatType = (id) => {
	return authClient().delete(`${API}/boatType/${id}`);
};

// Create boatType
export const postBoatType = (boatType) => {
	return authClient().post(`${API}/boatType`, boatType);
};

// Update boatType
export const updateBoatType = (id, boatType) => {
	return authClient().put(`${API}/boatType/${id}`, boatType);
};
